<template>
  <v-form ref="signupForm" v-model="formValidity">
    <v-container style="max-width:600px">
      <h2 class="pb-2">Signup</h2>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>First name</h4></v-col>
        <v-col class="mx-0 py-0 primary--text"><h4>Last name</h4></v-col>
      </v-row>
      <v-row>
        <v-col cols=6 class="py-0">
          <v-text-field
            v-model.trim="first"
            type="text"
            :rules="firstRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col class="py-0">
          <v-text-field
            v-model.trim="last"
            type="text"
            :rules="lastRules"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>Email</h4></v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-text-field
            xlabel="Email"
            type="email"
            v-model.trim="email"
            :rules="emailRules"
            :error-messages="emailErrors"
            outlined
            dense
            name="email"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>Password</h4></v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-text-field
            v-model.trim="password"
            :rules="passwordRules"
            :type="showPassword ? 'text' : 'password'"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>ZIP code</h4></v-col>
        <v-col class="mx-0 py-0 primary--text"><h4>Cell phone</h4></v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="py-0">
          <v-text-field
            v-model.trim="zipcode"
            type="text"
            :rules="zipcodeRules"
            :validate-on-blur="true"
            color="primary"
            inputmode="numeric"
            :error-messages="zipcodeErrors"
            outlined
            dense
            name="zipcode"
          ></v-text-field>
        </v-col>
        <v-col class="py-0">
          <v-text-field
            v-model.trim="cell"
            type="text"
            :rules="cellRules"
            color="primary"
            inputmode="numeric"
            @blur="formatCell"
            persistent-hint
            hint="The number we will use to call and text you"
            outlined
            dense
            name="cell"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mx-0 py-0 primary--text"><h4>Profile picture</h4></v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
            <v-file-input
              accept="image/jpeg,image/png"
              v-model="profilePic"
              prepend-icon="mdi-camera"
              :rules="profilePicRules"
              hint="Best if square. Large images can take a long time to upload."
              persistent-hint
              outlined
              dense
            ></v-file-input>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mx-0 pt-6 pb-2 primary--text"><h4>I am signing up as..</h4></v-col>
      </v-row>
      <v-row>
        <v-col cols=10 class="mt-0 pt-0 pl-4 pb-0">
          <v-checkbox
            label="Agent"
            v-model="isAgent"
            color="primary"
            class="mt-0 mb-0 pt-0 pb-0"
          ></v-checkbox>
        </v-col>
        <!-- <v-col cols=2 align-self="center" class="mt-0 mb-0 pt-0 text-center">
          <v-icon color="primary">mdi-information</v-icon>
        </v-col> -->
      </v-row>
      <v-row v-if="isAgent">
        <v-col class="mx-0 py-0 primary--text"><h4>Agent name</h4></v-col>
      </v-row>
      <v-row v-if="isAgent">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            v-model.trim="agentName"
            type="text"
            :rules="[validateAgentName]"
            hint="Your name or agency name as appropriate"
            persistent-hint
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols=10 class="mt-0 pt-0 pl-4 pb-0">
          <v-checkbox
            label="Artist"
            v-model="isArtist"
            color="primary"
            class="mt-0 mb-0 pt-0 pb-0"
          ></v-checkbox>
        </v-col>
        <!-- <v-col cols=2 align-self="center" class="mt-0 mb-0 pt-0 text-center">
          <v-icon color="primary">mdi-information</v-icon>
        </v-col> -->
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 py-0 primary--text"><h4>Artist name</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            v-model.trim="artistName"
            type="text"
            :rules="[validateArtistName]"
            hint="The name you use when performing as an artist"
            persistent-hint
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 pt-2 pb-0 primary--text"><h4>Artist bio</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-textarea
            v-model.trim="artistBio"
            type="text"
            :rules="[validateArtistBio]"
            counter
            outlined
            dense
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 py-0 primary--text"><h4>Artist repertoire</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-textarea
            v-model.trim="artistRepertoire"
            type="text"
            :rules="[validateArtistRepertoire]"
            counter
            outlined
            dense
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 py-0 primary--text"><h4>Artist video link</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            v-model.trim="artistVideoUrl"
            type="text"
            :rules="[validateArtistVideoUrl]"
            required
            outlined
            dense
            hint="YouTube only"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="isArtist && videoOfferUrl" align="center" justify="space-between" class="pa-4">
        <v-col class="mx-0 py-0" cols="12" md="8">
          <p>
            A standout video is key to landing top clients. Apply for Amplify through our partnership with
            <strong>LJR Creative</strong> for 10% off the highest quality video available at a reasonable price. Just tell them we sent you.
          </p>
        </v-col>
        <v-col class="mt-0 text-center" cols="12" md="4">
          <v-btn outlined :href="videoOfferUrl" target="_blank" color="primary">
            Apply for Amplify
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>Artist website</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            v-model.trim="artistWebsiteUrl"
            type="text"
            :rules="[validateArtistWebsiteUrl]"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="mx-0 py-0 primary--text"><h4>Picture for Artist page</h4></v-col>
      </v-row>
      <v-row v-if="isArtist">
        <v-col class="py-0 mt-0 mb-0">
            <v-file-input
              accept="image/jpeg,image/png"
              v-model="artistPicture"
              prepend-icon="mdi-camera"
              :rules="[validateArtistPicture]"
              outlined
              dense
              hint="Must be 16x9 aspect ratio. Large images can take a long time to upload."
              persistent-hint
              @change="handleArtistPictureFileChange"
            ></v-file-input>
        </v-col>
      </v-row>
      <!-- <v-row v-if="isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            label="Artist EPK link"
            v-model.trim="artistEpkUrl"
            type="text"
            :rules="[validateArtistEpkUrl]"
            required
          ></v-text-field>
        </v-col>
      </v-row> -->
      <v-row v-if="!isArtist">
        <v-col cols=10 class="mt-0 pt-0 pl-4 pb-0">
          <v-checkbox
            label="Musician"
            v-model="isMusician"
            color="primary"
            class="mt-0 mb-0 pt-0 pb-0"
          ></v-checkbox>
        </v-col>
        <!-- <v-col cols=2 align-self="center" class="mt-0 mb-0 pt-0 text-center">
          <v-icon color="primary">mdi-information</v-icon>
        </v-col> -->
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>Musician name</h4></v-col>
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col class="mt-0 mb-0 pt-0 pb-4">
          <v-text-field
            v-model.trim="musicianName"
            type="text"
            :rules="[validateMusicianName]"
            outlined
            dense
            hint="The name you use when performing as an musician"
            persistent-hint
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>Select at least one instrument</h4></v-col>
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col class="mb-0 pt-0 pb-0">
          <v-checkbox class="mt-0 mb-1"
            dense
            v-for="(instrument, index) in instruments" :key="instrument"
            :label="instrument"
            :value="instrument"
            v-model="selectedInstruments"
            color="primary"
            :rules="[v => v.length > 0 || 'At least one instrument must be selected']"
            :hide-details="index !== instruments.length - 1"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col class="mx-0 pt-4 pb-0 primary--text"><h4>Meal Preference</h4></v-col>
      </v-row>
      <v-row v-if="isMusician || isArtist">
        <v-col>
          <v-radio-group v-model="mealPref" class="mt-0 pt-0">
            <v-radio
              v-for="pref in mealPrefs"
              :key="pref"
              :label="pref"
              :value="pref"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row v-if="(isMusician || isArtist) && mealPref == 'other'">
        <v-col class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            label="Other meal preference"
            v-model="mealPrefOther"
            type="text"
            :rules="[validateMealPrefOther]"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols=10 class="py-0 pl-4">
          <v-checkbox
            label="I agree to terms and conditions and privacy policy"
            v-model="agreeToTerms"
            color="primary"
            :rules="agreeToTermsRules"
            dense
          ></v-checkbox>
        </v-col>
        <v-col cols=2 align-self="center" class="mb-0 py-0 text-center">
            <a class="b-link" :href="tcLink" target="_blank"><v-icon color="primary">mdi-information</v-icon></a>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols=12 class="pt-0 pl-4">
          <v-checkbox
            label="I agree to receive text messages from BookMe"
            hint="Sending texts is part of how BookMe notifies you, so it is required for an account. Will not be used for marketing purposes"
            persistent-hint
            v-model="agreeToSMS"
            color="primary"
            :rules="agreeToSMSRules"
            dense
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-btn color="primary" block large class="text-none f-rounded" :disabled="!formValidity || (!isAgent && !isArtist && !isMusician)" :loading="loading" @click="signupDlg = true">Continue</v-btn>
    </v-container>
    <!-- <v-dialog v-model="signupDlg" persistent :fullscreen="$vuetify.breakpoint.width < 501">
    </v-dialog> -->
    <v-dialog v-model="signupDlg" persistent :fullscreen="$vuetify.breakpoint.width < 501" max-width="390" overlay-opacity=.7>
      <!-- <v-card style="border-radius: 10px"> -->
      <v-card>
        <div class="text-center py-6 mb-0">
          <h2 class="b-header">Look OK?</h2>
        </div>
        <v-simple-table class="px-4 py-8 b-text">
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Name</td>
                <td>{{first}} {{last}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{email}}</td>
              </tr>
              <tr>
                <td>ZIP</td>
                <td>{{zipcode}}</td>
              </tr>
              <tr>
                <td>Cell phone</td>
                <td>{{cell}}</td>
              </tr>
              <tr v-if="isAgent">
                <td>Agent name</td>
                <td>{{agentName}}</td>
              </tr>
              <tr v-if="isArtist">
                <td>Artist name</td>
                <td>{{artistName}}</td>
              </tr>
              <tr v-if="isArtist | isMusician">
                <td>Musician name</td>
                <td>{{musicianName}}</td>
              </tr>
              <tr v-if="isArtist | isMusician">
                <td>Instrument(s)</td>
                <td>
                  <p v-for="instrument in selectedInstruments" :key="instrument" class="mb-0">{{instrument}}</p>
                </td>
              </tr>
              <tr v-if="isArtist | isMusician">
                <td>Meal preference</td>
                <td v-if="mealPref == 'other'">{{mealPrefOther}}</td>
                <td v-else>{{mealPref}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions class="justify-center pb-6 px-4">
          <v-col cols=6><v-btn dark block large color="primary" style="10px" class="text-none" @click="signupDlg = false">Change</v-btn></v-col>
          <v-col cols=6><v-btn dark block large color="primary" style="10px" class="text-none" :loading="loading" @click="signup">Continue</v-btn></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import axios from "axios";
import bmutils from '../bmutils.js'
export default {
  name: "Signup",
  data: () => ({
    agreeToTerms: false,
    agreeToTermsRules: [
      value =>
        !!value ||
        'You must agree to the terms and conditions and privacy policy to sign up for an account.'
    ],
    agreeToSMS: false,
    agreeToSMSRules: [
      value =>
        !!value ||
        'You must agree to receive text messages to sign up for an account.'
    ],
    isAgent: false,
    agentName: '',
    isArtist: false,
    artistName: '',
    artistPicture: null,
    artistBio: '',
    artistRepertoire: '',
    artistVideoUrl: '',
    artistWebsiteUrl: '',
    artistEpkUrl: '',
    isMusician: false,
    musicianName: '',
    instruments: [],
    selectedInstruments: [],
    first: '',
    firstRules: [
      value => !!value || 'Required.',
    ],
    last: '',
    lastRules: [
      value => !!value || 'Required.',
    ],
    email: '',
    emailRules: [
      value => !!value || 'Required.',
      value => value.indexOf('@') !== 0 || 'Email should have a username.',
      value => value.includes('@') || 'Email should include an @ symbol.',
      // value =>
      //   value.indexOf('.') - value.indexOf('@') > 1 ||
      //   'Email should contain a valid domain.',
      value => value.includes('.') || 'Email should include a period symbol.',
      value =>
        value.indexOf('.') <= value.length - 3 ||
        'Email should contain a valid domain extension.'
    ],
    emailErrors: [],
    password: '',
    passwordRules: [
      value => !!value || 'Required',
      value => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,18}$/.test(value) || 'Password must be 8 - 18 characters, at least 1 lowercase, 1 uppercase, 1 special, and 1 number'
    ],
    showPassword: false,
    zipcode: '',
    zipcodeRules: [
      value => !!value || 'Required.',
      value => /^[0-9]{5}$/.test(value) || 'ZIP must be 5 digits'
    ],
    zipcodeErrors: [],
    city: '',
    state: '',
    cell: '',
    cellRules: [
      value => !!value || 'Required.',
    ],
    mealPrefs: [],
    mealPref: 'no preference',
    mealPrefOther: '',
    profilePic: null,
    profilePicRules: [
      value => !!value || 'Required'
    ],
    videoOfferUrl: '',
    loading: false,
    signupDlg: false,
    formValidity: false
  }),
  mounted() {
    if(this.$store.state.login) {
      // can't signup if logged in
      this.$router.push("home")
    }
    this.initialize()
  },
  computed: {
    emailInvalidMsg: function() {
      return this.$store.state.emailInvalidMsg
    },
    artistId: function() {
      if(this.$store.state.user.artist.id) {
        return this.$store.state.user.artist.id
      }
      return 0
    },
    tcLink: function() {
      let link = this.$store.state.appBaseURL + 'bookme-terms-and-conditions.html'
      let separator = '?'
      if(this.isAgent) {
        link += separator + 'agent=true'
        separator = '&'
      }
      if(this.isArtist || this.isMusician) {
        link += separator + 'performer=true'
      }
      return link
    },
    apiErrorMsg: function() {
      return this.$store.state.apiError.userMessage
    }
  },
  watch: {
    first: function() {
      this.agentName = this.first + ' ' + this.last
      this.artistName = this.first + ' ' + this.last
      this.musicianName = this.first + ' ' + this.last
    },
    last: function() {
      this.agentName = this.first + ' ' + this.last
      this.artistName = this.first + ' ' + this.last
      this.musicianName = this.first + ' ' + this.last
    },
    email: function() {
      if(this.emailErrors.length > 0) {
        this.emailErrors = []
      }
    },
    zipcode: function() {
      if(this.zipcodeErrors.length > 0) {
        this.zipcodeErrors = []
      }
    },
  },
  methods: {
    async initialize() {
      await this.getConfig()
    },
    async getConfig() {
      this.$store.commit('SET_LOADING_STATUS', true);
      this.loading = true
      try {
        let result = await axios.get("configuration");
        this.instruments = result.data.instruments
        this.mealPrefs = result.data.meal_preferences
        this.videoOfferUrl = result.data.video_offer_url
      } catch(err) {
        //console.log(err)
      }
      this.$store.commit('SET_LOADING_STATUS', false);
      this.loading = false
    },
    formatCell() {
      this.cell = bmutils.formatCell(this.cell)
    },
    resetForm() {
      this.$refs.signUpForm.reset()
    },
    resetValidation() {
      this.$refs.signUpForm.resetValidation()
    },
    async validateEmail() {
      if(this.email == '') {
        this.$store.commit('SET_EMAIL_INVALID_MSG', null)
        return
      }
      await this.$store.dispatch('validateEmail', {'email': this.email})
      if(this.emailInvalidMsg) {
        this.emailErrors = this.emailInvalidMsg
      } else {
        this.emailErrors = []
      }
    },
    async validateZipcode() {
      if(this.zipcode == '') {
        return
      }
      await this.$store.dispatch('validateZipcode', {'zipcode': this.zipcode})
      if(this.$store.state.zipcode) {
        this.city = this.$store.state.zipcode.city
        this.state = this.$store.state.zipcode.state
        this.zipcodeErrors = []
      } else {
        this.zipcodeErrors = 'ZIP not found'
      }
    },
    validateAgentName(value) {
      return this.isAgent ? (!!value || 'Required') : true
    },
    validateArtistName(value) {
      return this.isArtist ? (!!value || 'Required') : true
    },
    validateArtistPicture(value) {
      return this.isArtist ? (!!value || 'Required') : true
    },
    handleArtistPictureFileChange() {
      const file = this.artistPicture
      if (!file) return;

      // Read the selected file to validate the aspect ratio
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const aspectRatio = img.width / img.height;
          if (Math.abs(aspectRatio - 16 / 9) > 0.01) {
            alert("The selected image is not 16x9 aspect ratio, so it will be scaled to fit and might not look great. For best results choose a 16x9 aspect ratio image.");
          }
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    validateArtistBio(value) {
      if(this.isArtist) {
        if(value) {
          if(value.length > 7000) {
            return 'Max 7000 characters'
          }
          return true
        }
        return 'Required'
      }
      return true
    },
    validateArtistRepertoire(value) {
      if(this.isArtist) {
        if(value) {
          if(value.length > 7000) {
            return 'Max 7000 characters'
          }
          return true
        }
        return 'Required'
      }
      return true
    },
    validateArtistVideoUrl(value) {
      return this.isArtist ? (!!value || 'Required') : true
    },
    validateArtistWebsiteUrl(value) {
      return this.isArtist ? (!!value || 'Required') : true
    },
    validateArtistEpkUrl(value) {
      return this.isArtist ? (!!value || 'Required') : true
    },
    validateMusicianName(value) {
      return this.isMusician || this.isArtist ? (!!value || 'Required') : true
    },
    validateMealPrefOther(value) {
      return (this.isMusician || this.isArtist) && this.mealPref == 'other' ? (!!value || 'Please specify meal preference') : true
    },
    // validateForm() {
    //   this.$refs.signUpForm.validate()
    // },
    async uploadProfilePic() {
      let fd = new FormData();
      fd.append("pic", this.profilePic, this.profilePic.name);
      await this.$store.dispatch("uploadProfilePic", fd);
      if(this.apiErrorMsg) {
        this.$emit('error', this.apiErrorMsg)
			} else {
        //this.profilePic = null;
      }
    },
    async uploadArtistPicture() {
      let fd = new FormData();
      fd.append("pic", this.artistPicture, this.artistPicture.name);
      await this.$store.dispatch("uploadArtistPic", fd);
      if(this.apiErrorMsg) {
        this.$emit('error', this.apiErrorMsg)
			} else {
        //this.artistPicture = null;
      }
    },
    async signup() {
      this.loading = true
      await this.validateEmail()
      await this.validateZipcode()
      if(this.emailErrors.length || this.zipcodeErrors.length || !this.$refs.signupForm.validate()) {
        this.loading = false
        this.signupDlg = false
        return
      }
      let data = {
        first: this.first,
        last: this.last,
        email: this.email,
        password: this.password,
        city: this.city,
        state: this.state,
        zipcode: this.zipcode,
        cell_phone: this.cell,
        send_email: true
      }
      if(this.isAgent) {
        data.agent = {
          name: this.agentName,
        }
      }
      if(this.isArtist) {
        data.artist = {
          name: this.artistName,
          bio: this.artistBio,
          repertoire: this.artistRepertoire,
          video_url: this.artistVideoUrl,
          website_url: this.artistWebsiteUrl,
          epk_url: this.artistEpkUrl,
          musician_name: this.musicianName
        }
        data.artist.instruments = [];
        for(let i = 0; i < this.selectedInstruments.length; i++) {
          data.artist.instruments.push(this.selectedInstruments[i])
        }
      }
      if(this.isMusician && !this.isArtist) {
        data.musician = { name: this.musicianName }
        data.musician.instruments = [];
        for(let i = 0; i < this.selectedInstruments.length; i++) {
          data.musician.instruments.push(this.selectedInstruments[i])
        }
      }
      if(this.isMusician || this.isArtist) {
        if(this.mealPref == 'other') {
          data.meal_preference = this.mealPrefOther
        } else {
          data.meal_preference = this.mealPref
        }
      }
      await this.$store.dispatch('signup', data)
      if(this.apiErrorMsg) {
        this.loading = false
        this.$emit('error', this.apiErrorMsg)
      } else {
        await this.$store.dispatch('login', { email: this.email, password: this.password })
        if(this.apiErrorMsg) {
          this.loading = false
          this.$emit('error', this.apiErrorMsg)
        } else {
          await this.uploadProfilePic()
          if(this.isArtist) {
            await this.uploadArtistPicture()
          }
          this.$router.push('signup-2')
        }
			}
      this.signupDlg = false
    }
  }
}
</script>

<style scoped>
.b-link {
  font-weight: bold;
  text-decoration: none;
}
</style>
